import { render } from "./ChannelGrid.vue?vue&type=template&id=2e14231e&scoped=true"
import script from "./ChannelGrid.vue?vue&type=script&lang=js"
export * from "./ChannelGrid.vue?vue&type=script&lang=js"

import "./ChannelGrid.vue?vue&type=style&index=0&id=2e14231e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3966428095/src/eelam-tv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e14231e"]])

export default __exports__